import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';

import { serverAxios } from '../../http';
import { AxiosResponse } from 'axios';
import { IGetSimpleListFilters, IGetSimpleListResponse } from 'models/http/common';

class FareGroupHttp {
  private static route = '/fareGroup';

  public async getSimple(_?: IGetSimpleListFilters, abortController?: AbortController): Promise<IGetSimpleListResponse> {
    return serverAxios
      .get(`${FareGroupHttp.route}/simple`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSimpleListResponse>) => {
        return response.data;
      });
  }
}

export default FareGroupHttp;
